module.exports = __webpack_public_path__ + "static/media/sir.8e0a344d.png";